const INFO_OVERLAY_CONTENT = {
  VIDEO_INFO: 'videoInfo',
  ALL_CARDS: 'allCards',
};

export default INFO_OVERLAY_CONTENT;
